<template>
  <div class="sort-by">
    <span class="title" @click.stop.prevent="show"
      >{{ title }}<i class="down-arrow-icon"></i
    ></span>
    <div class="dropdown-box" :id="componentID">
      <ul class="menu-box">
        <li class="title">Price</li>
        <li
          @click="selectMenu('price_desc')"
          :class="{ 'active-item': selectedSort == 'price_desc' }"
        >
          High to Low
        </li>
        <li
          @click="selectMenu('price_asc')"
          :class="{ 'active-item': selectedSort == 'price_asc' }"
        >
          Low to High
        </li>
        <li class="title">Rating</li>
        <li
          @click="selectMenu('rating_desc')"
          :class="{ 'active-item': selectedSort == 'rating_desc' }"
        >
          High to Low
        </li>
        <li
          @click="selectMenu('rating_asc')"
          :class="{ 'active-item': selectedSort == 'rating_asc' }"
        >
          Low to High
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as types from '../../store/mutation-types'

export default {
  name: 'sort-by',
  props: {},
  data() {
    return {
      target: '',
      componentID: new Date().getTime().toString() + 'C',
      selectedSort: '',
      title: 'SORT BY'
    }
  },
  methods: {
    show() {
      this.$store.dispatch(types.SET_GLOBAL_DROPDOWNMODE, 'clear')
      const el = window.document.getElementById(this.componentID)
      // console.log(el.className)
      if (el.className === 'dropdown-box') {
        el.className += ' active'
      } else {
        el.className = 'dropdown-box'
      }
    },
    selectMenu(sortValue) {
      switch (sortValue) {
        case 'price_desc':
          this.title = 'Price High to Low'
          break
        case 'price_asc':
          this.title = 'Price Low to High'
          break
        case 'rating_desc':
          this.title = 'Rating High to Low'
          break
        case 'rating_asc':
          this.title = 'Rating High to Low'
          break
        default: {
          this.title = 'SORT BY'
        }
      }
      this.selectedSort = sortValue
      this.$emit('model', sortValue)
    }
  },
  updated() {},
  computed: {}
}
</script>

<style lang="scss" scoped>
.sort-by {
  min-width: 87px;
  /*border: 1px solid red;*/
  position: relative;

  .title {
    width: 102px;
    height: 23px;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    text-align: left;
    color: #000000;
    cursor: pointer;
    .down-arrow-icon {
      margin: 0 0 0 8px;
      width: 16px;
      height: 9px;
      /*border: 1px solid red;*/
      display: inline-block;
      background-image: url('../../assets/images/etc/down-arrow.png');
    }
  }

  .dropdown-box {
    width: 139px;
    height: 0;
    z-index: -1;
    margin: 20px 0 0 0;
    background-color: #ffffff;
    position: absolute;
    border: 1px solid #cbcbcb;
    visibility: hidden;
    opacity: 0;

    &:before {
      position: absolute;
      top: -12px;
      left: 30px;
      z-index: 1001;
      content: '';
      width: 20px;
      height: 20px;
      border-top: 1px solid #cbcbcb;
      border-right: 1px solid #cbcbcb;
      transform: rotate(315deg);
      background-color: #fff;
    }

    .menu-box {
      width: 100px;
      margin: 20px auto auto auto;
      position: relative;
      padding: 0;
      .title {
        line-height: 30px;
        font-weight: 600;
      }

      li {
        line-height: 25px;
        cursor: pointer;
        margin: 0 0 10px 0;
      }

      .active-item {
        font-weight: 600;
      }

      li:hover {
        font-weight: 600;
      }
    }

    -webkit-transition-property: width height background-color font-size left
      top transform -webkit-transform color;
    -webkit-transition-duration: 0.3s;
    -webkit-transition-timing-function: ease-in-out;

    -moz-transition-property: width height background-color font-size left top
      transform -moz-transform color;
    -moz-transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in-out;

    -ms-transition-property: width height background-color font-size left top
      transform -ms-transform color;
    -ms-transition-duration: 0.3s;
    -ms-transition-timing-function: ease-in-out;

    -o-transition-property: width height background-color font-size left top
      transform -o-transform color;
    -o-transition-duration: 0.3s;
    -o-transition-timing-function: ease-in-out;

    transition-property: width height background-color font-size left top
      transform transform color;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
  }

  .active {
    height: 243px;
    z-index: 1000;
    opacity: 1;
    visibility: visible;

    -webkit-transition-property: width height background-color font-size left
      top transform -webkit-transform color;
    -webkit-transition-duration: 0.3s;
    -webkit-transition-timing-function: ease-in-out;

    -moz-transition-property: width height background-color font-size left top
      transform -moz-transform color;
    -moz-transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in-out;

    -ms-transition-property: width height background-color font-size left top
      transform -ms-transform color;
    -ms-transition-duration: 0.3s;
    -ms-transition-timing-function: ease-in-out;

    -o-transition-property: width height background-color font-size left top
      transform -o-transform color;
    -o-transition-duration: 0.3s;
    -o-transition-timing-function: ease-in-out;

    transition-property: width height background-color font-size left top
      transform transform color;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
  }
}
</style>
